// app/studente/studenteDetail.js

(function () {
    'use strict';
    var controllerId = 'dashboard_Studente';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', '$scope', '$filter', 'datacontext', 'sectionMenu', '_', '$uibModal', 'bootstrap.dialog', '$translate', dashboard_Studente]);

    function dashboard_Studente($rootScope, common, $scope, $filter, datacontext, sectionMenu, _ ,$uibModal, bdialog, $translate) {
        $rootScope.dashview = " dashview";
        var vm = this;
        vm.title = 'Studente';
        vm.sectionMenu = sectionMenu.setSection('');

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();

        //filter per Anno: default l'anno corrente        
        vm.filter = {};
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;

        vm.loading = false;

        vm.getAll = getAllFunc;
        vm.registrati = registrati;
        vm.showDownloads = showDownloads;
        vm.showAvvisi = showAvvisi;

        vm.dashboard = {};
        vm.dashboard.classe = "-";
        vm.dashboard.docenti = 0;
        vm.dashboard.sessioniDisponibili = 0;
        vm.dashboard.sessioniEffettuate = 0;
        vm.dashboard.test = 0;        
        vm.downloads = [];
        vm.downloadsTop3 = [];
        vm.avvisi = [];
        vm.avvisiTop3 = [];
        vm.registraClasse = false;

        // ---- ACTIVATE -------
        activate();        

        function activate() {
            var promises = [$rootScope.getWhoAmI()];
            common.activateController(promises, controllerId)
                .then(function () {
                    vm.currentLanguage = $rootScope.lingua;
                    if (!vm.fAnno)
                        vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
                    getAllFunc();
                });
        }

        function getAllFunc() {
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            $rootScope.annoScolastico = vm.filter.anno;
            getDashboard();
            vm.loading = false;
            getSessions();
            getAvvisi();
        }

        function registrati() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dashboard/modal/studRegistraClasse.html?version=43',
                controller: 'studRegistraClasse'
            });

            modalInstance.result.then(function () {
                getDashboard();
                getSessions();
                getAvvisi();
            });
        }

        function getDashboard() {
            vm.registraClasse = false;
            datacontext.dashboard_getStudente(vm.filter.anno).then(function (data) {                
                if (data.classe.length == 0)
                {
                    data.classe = '-';

                    if (vm.fAnno == $rootScope.annoCorrente) {
                        vm.registraClasse = true;
                        registrati();
                    }
                }
                vm.dashboard = data;

                if ($rootScope.mdUpdate != undefined && $rootScope.mdUpdate == true) {
                    if (vm.currentLanguage == 'it') {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            keyboard: false,
                            templateUrl: '/app/dashboard/modal/avvisoAggiornamenti.html?version=43',
                            controller: 'avvisoAggiornamenti',
                            windowClass: 'welcomeBody update'
                        });
                    } else {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            keyboard: false,
                            templateUrl: '/app/dashboard/modal/avvisoAggiornamenti.html?version=43',
                            controller: 'avvisoAggiornamenti',
                            windowClass: 'welcomeBody update welcome-en'
                        });
                    }

                }
            });
        }

        function getSessions() {
            $scope.graficoPerformance = {
                'type': 'AreaChart',
                'options': {
                    'legend': { 'position': 'none' },
                    'colors': ['#3C454E'],
                    'vAxis': {
                        'title': $translate.instant('Punteggio') +' in %',
                        'titleTextStyle': { color: '#333' },
                        'minValue': 0,
                        'maxValue': 100
                    },
                    'hAxis': {
                        'textPosition': 'none',
                        'gridlines': { 'count': 10 }
                    },
                    'pointSize': 8
                },
                'formatters': {
                    'number': [
                        {
                            'columnNum': 1,
                            'decimalSymbol': ',',
                            'fractionDigits': 1,
                            'groupingSymbol': '.'
                        }
                    ]
                }
            };

            vm.loading = true;
            // datacontext.session_getAllHistory().then(function (data) {
            datacontext.dashboard_getAllStudenteSession(vm.filter.anno).then(function (data) {
                vm.showPerformance = true;
                if (data == null || data.length == 0) {
                    $scope.graficoPerformance.data = {
                        "cols": [
                            { id: "description", label: $translate.instant('Data'), type: "string" },
                            { id: "score", label: $translate.instant('Punteggio'), type: "number" }
                        ],
                        "rows": []
                    };

                    vm.loading = false;
                    return;
                }

                vm.sessionCount = data.length;
                var sortedPerformance = _.sortBy(data, 'Data');
                vm.primaData = _.first(sortedPerformance).Data;
                vm.ultimaData = _.last(sortedPerformance).Data;

                $scope.graficoPerformance.data = {
                    "cols": [
                        { id: "description", label: $translate.instant('Data'), type: "string" },
                        { id: "score", label: $translate.instant('Punteggio'), type: "number" }
                    ],
                    "rows": []
                };

                sortedPerformance.forEach(function (obj) {
                    var item = {};
                    item.c = [];

                    var desc = $filter('date')(obj.dtPerformed);

                    item.c.push({ v: desc });
                    item.c.push({ v: obj.Percentuale });

                    $scope.graficoPerformance.data.rows.push(item);
                });

                vm.loading = false;
            });
        }

        function getAvvisi() {
            vm.downloads = [];
            vm.downloadsTop3 = [];
            vm.avvisi = [];
            vm.avvisiTop3 = [];

            datacontext.avviso_getAllStudente().then(function (data) {
                vm.downloads = _.filter(data, function (o) { return o.bDownload == true });
                vm.avvisi = _.filter(data, function (o) { return o.bDownload == false });

                var dCount = vm.downloads.length >= 3 ? 3 : vm.downloads.length;
                var aCount = vm.avvisi.length >= 2 ? 2 : vm.avvisi.length;

                for (var i = 0; i < dCount; i++) {
                    vm.downloadsTop3.push(vm.downloads[i]);
                }

                for (var j = 0; j < aCount; j++) {
                    vm.avvisiTop3.push(vm.avvisi[j]);
                }
            });
        }

        function showDownloads() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/dashboard/modal/elencoAvvisi.html?version=43",
                controller: "elencoAvvisi",
                resolve: {
                    avvisi: function () {
                        return vm.downloads;
                    },
                    download: function () {
                        return true;
                    }
                }
            });
        }

        function showAvvisi() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/dashboard/modal/elencoAvvisi.html?version=43",
                controller: "elencoAvvisi",
                resolve: {
                    avvisi: function () {
                        return vm.avvisi;
                    },
                    download: function () {
                        return false;
                    }
                }
            });
        }
    }
})();